export default __webpack_public_path__ + "static/media/contact_bg_tongdian.323b13a3.jpg";